import { openDB } from "idb";

const DB_NAME = "vendorvault";
const DB_VERSION = 1;

let dbPromise = null;

export function getDB() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains("products")) {
          db.createObjectStore("products", { keyPath: "product_id" });
        }
        if (!db.objectStoreNames.contains("events")) {
          db.createObjectStore("events", { keyPath: "event_id" });
        }
        if (!db.objectStoreNames.contains("meta")) {
          db.createObjectStore("meta");
        }
        if (!db.objectStoreNames.contains("queue")) {
          db.createObjectStore("queue", { keyPath: "id", autoIncrement: true });
        }
      },
    });
  }
  return dbPromise;
}

/* ---------- Products ---------- */
export async function cacheProducts(products) {
  const db = await getDB();
  const tx = db.transaction("products", "readwrite");
  await tx.store.clear();
  for (const p of products) {
    await tx.store.put(p);
  }
  await tx.done;
}
export async function readProducts() {
  const db = await getDB();
  return db.getAll("products");
}
export async function readProduct(id) {
  const db = await getDB();
  return db.get("products", id);
}

/* ---------- Events ---------- */
export async function cacheEvents(events) {
  const db = await getDB();
  const tx = db.transaction("events", "readwrite");
  await tx.store.clear();
  for (const e of events) {
    await tx.store.put(e);
  }
  await tx.done;
}
export async function readEvents() {
  const db = await getDB();
  return db.getAll("events");
}
export async function readEvent(id) {
  const db = await getDB();
  return db.get("events", id);
}

/* ---------- Meta ---------- */
export async function setMeta(key, value) {
  const db = await getDB();
  return db.put("meta", value, key);
}
export async function getMeta(key) {
  const db = await getDB();
  return db.get("meta", key);
}

/* ---------- Sync ---------- */
export async function clearAll() {
  const db = await getDB();
  for (const name of ["products", "events", "meta", "queue"]) {
    const tx = db.transaction(name, "readwrite");
    await tx.store.clear();
    await tx.done;
  }
}
